/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewShiftTypeDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewShiftTypeDto } from '../api-models';
// @ts-ignore
import { UpdateShiftTypeDto } from '../api-models';
/**
 * ShiftTypeApi - axios parameter creator
 * @export
 */
export const ShiftTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftTypeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ShiftType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftTypeIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shiftTypeIdGet', 'id', id)
            const localVarPath = `/ShiftType/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftTypeDto} [updateShiftTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftTypeIdPut: async (id: number, updateShiftTypeDto?: UpdateShiftTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shiftTypeIdPut', 'id', id)
            const localVarPath = `/ShiftType/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShiftTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShiftTypeApi - functional programming interface
 * @export
 */
export const ShiftTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShiftTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shiftTypeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewShiftTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shiftTypeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shiftTypeIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewShiftTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shiftTypeIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftTypeDto} [updateShiftTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shiftTypeIdPut(id: number, updateShiftTypeDto?: UpdateShiftTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shiftTypeIdPut(id, updateShiftTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShiftTypeApi - factory interface
 * @export
 */
export const ShiftTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShiftTypeApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftTypeGet(options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewShiftTypeDto> {
            return localVarFp.shiftTypeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShiftTypeApiShiftTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftTypeIdGet(requestParameters: ShiftTypeApiShiftTypeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewShiftTypeDto> {
            return localVarFp.shiftTypeIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShiftTypeApiShiftTypeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftTypeIdPut(requestParameters: ShiftTypeApiShiftTypeIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.shiftTypeIdPut(requestParameters.id, requestParameters.updateShiftTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for shiftTypeIdGet operation in ShiftTypeApi.
 * @export
 * @interface ShiftTypeApiShiftTypeIdGetRequest
 */
export interface ShiftTypeApiShiftTypeIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ShiftTypeApiShiftTypeIdGet
     */
    readonly id: number
}

/**
 * Request parameters for shiftTypeIdPut operation in ShiftTypeApi.
 * @export
 * @interface ShiftTypeApiShiftTypeIdPutRequest
 */
export interface ShiftTypeApiShiftTypeIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ShiftTypeApiShiftTypeIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateShiftTypeDto}
     * @memberof ShiftTypeApiShiftTypeIdPut
     */
    readonly updateShiftTypeDto?: UpdateShiftTypeDto
}

/**
 * ShiftTypeApi - object-oriented interface
 * @export
 * @class ShiftTypeApi
 * @extends {BaseAPI}
 */
export class ShiftTypeApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTypeApi
     */
    public shiftTypeGet(options?: AxiosRequestConfig) {
        return ShiftTypeApiFp(this.configuration).shiftTypeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShiftTypeApiShiftTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTypeApi
     */
    public shiftTypeIdGet(requestParameters: ShiftTypeApiShiftTypeIdGetRequest, options?: AxiosRequestConfig) {
        return ShiftTypeApiFp(this.configuration).shiftTypeIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShiftTypeApiShiftTypeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTypeApi
     */
    public shiftTypeIdPut(requestParameters: ShiftTypeApiShiftTypeIdPutRequest, options?: AxiosRequestConfig) {
        return ShiftTypeApiFp(this.configuration).shiftTypeIdPut(requestParameters.id, requestParameters.updateShiftTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}
